<template>
  <div
    :class="[
      'asc-raw-report',
      isReportArray ? 'asc-raw-report--multiple' : 'asc-raw-report--sheet',
    ]"
  >
    <asc-spinner-wrapper :loading="loading">
      <div class="asc-raw-report--text-container" v-html="getReportText"></div>
    </asc-spinner-wrapper>
  </div>
</template>

<script>
import { AscRawReportMixin } from '@/components/mixins'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'

export default {
  name: 'AscRawReport',

  components: {
    AscSpinnerWrapper,
  },

  mixins: [AscRawReportMixin],

  computed: {
    isReportArray() {
      return Array.isArray(this.reportText)
    },
    getReportText() {
      if (this.isReportArray) {
        let report = ''
        this.reportText.forEach(item => {
          report += item
        })
        return report.replace(/\n/g, '<br />')
      }
      return this.reportText.replace(/\n/g, '<br />')
    },
  },
}
</script>

<style lang="scss">
.asc-raw-report {
  margin-bottom: 16px;

  &--sheet {
    padding: 10px;
    background-color: $gray-200;
    overflow-y: auto;
  }

  &--multiple {
    padding: 10px;
    overflow-y: auto;
  }
}

.asc-raw-report--text-container {
  padding: 4px 12px;
  word-wrap: break-word;
  max-height: 400px;
  min-height: 300px;

  & pre {
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}
</style>
